import type { ColorValue, FontSize } from '@frontend/constants';
import { match } from '@frontend/duck-tape';
import type { IconColorVariant } from '@frontend/web-react';
import { Icon, Text, XStack } from '@frontend/web-react';
import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';
import type { ClassName } from '@frontend/web-utils';
import { concatClasses } from '@frontend/web-utils';

type CardBadgeProps = {
  containerClassName?: ClassName;
  iconColor?: IconColorVariant;
  leftIconName?: IconName;
  size: 'lg' | 'md' | 'sm';
  text: string;
  textClassName?: ClassName;
  textColor?: ColorValue;
};

const getSizeStyle = (size: 'lg' | 'md' | 'sm'): { className: ClassName; text: string } =>
  match(size)
    .with('sm', () => ({
      className: 'rounded-md px-sx',
      text: 'caption',
    }))
    .with('md', () => ({
      className: 'rounded-md px-sm py-xs',
      text: 'p-sm',
    }))
    .with('lg', () => ({
      className: 'rounded-lg px-md py-sm',
      text: 'p-md',
    }))
    .exhaustive();

export const CardBadge = ({
  containerClassName,
  iconColor,
  leftIconName,
  size,
  text,
  textClassName,
}: CardBadgeProps) => (
  <XStack
    className={concatClasses(getSizeStyle(size).className, 'items-center gap-xs inline-flex', containerClassName)}
  >
    {leftIconName ? <Icon color={iconColor || 'secondary'} name={leftIconName} size={size} /> : null}
    <Text className={textClassName} color="secondary" type={getSizeStyle(size).text as FontSize}>
      {text}
    </Text>
  </XStack>
);
